import React, { useEffect } from 'react';
import moment from "moment";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { CustomDatePicker, DateWrapper, MobDatePicker } from "./styles";
import { DisplayFlex } from "../../../../CommonComponents/commonStyles";

const onChange = (value, dateString, toTimeFrame) => {
  toTimeFrame({ value, dateString });
}

const onStartDate = (dateString, startDate) => {
  startDate(dateString);
}

const onEndDate = (dateString, endDate) => {
  endDate(dateString);
}

const disabledEndDate = (current, originalOpenDate) => {
  let isDisabled = false
  if (originalOpenDate) {
    if (current && current < moment(originalOpenDate).subtract(1, "days")) {
      isDisabled = true;
    }
  }
  if (current && current > moment().endOf('day')) {
    isDisabled = true;
  }
  return isDisabled;
}

const disabledStartDate = (current, calendarEndDate) => {
  let endDate = moment(calendarEndDate)
  return current && current > endDate;
}


export const DateSelectorComponent = ({ toTimeFrame, startDate, endDate, originalOpenDate, defaultValue, calendarEndDate, open }) => {

  return (
    <DateWrapper id="transactionSummary" data-test="transaction-date-selector">
      {window.screen.availWidth < 576 ? <DisplayFlex style={{ flexDirection: "column" }}>
        <MobDatePicker
          data-test="transaction-date-selector-MobDatePicker-Start"
          placeholder={["Start Date"]}
          aria-labelledby="Start Date"
          disabledDate={(current) => disabledStartDate(current, calendarEndDate)}
          defaultValue={defaultValue[0]}
          format={"MM/DD/YYYY"}
          getCalendarContainer={() => document.getElementById("transactionSummary")}
          onChange={(dateString) => onStartDate(dateString, startDate)} />
        <MobDatePicker
          data-test="transaction-date-selector-MobDatePicker-End"
          placeholder={["End Date"]}
          aria-labelledby="End Date"
          defaultValue={defaultValue[1]}
          disabledDate={(current) => disabledEndDate(current, originalOpenDate)}
          format={"MM/DD/YYYY"}
          getCalendarContainer={() => document.getElementById("transactionSummary")}
          onChange={(dateString) => onEndDate(dateString, endDate)} />
      </DisplayFlex>
        :
        <CustomDatePicker
          data-test="transaction-date-selector-CustomDatePicker"
          placeholder={["Start Date", "End Date"]}
          defaultValue={defaultValue}
          disabledDate={(current) => disabledEndDate(current, originalOpenDate)}
          getCalendarContainer={() => document.getElementById("transactionSummary")}
          open={open}
          format={"MM/DD/YYYY"}
          onChange={(value, dateString) => onChange(value, dateString, toTimeFrame)}
        />
      }
    </DateWrapper>
  );
}

DateSelectorComponent.propTypes = {
  defaultValue: PropTypes.arrayOf(PropTypes.object),
  calendarEndDate: PropTypes.string,
  open: PropTypes.bool,
  endDate: PropTypes.func.isRequired,
  startDate: PropTypes.func.isRequired,
  toTimeFrame: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  originalOpenDate: state.getIn(["messaging", "messages", "additionalAccountDetails", "originalOpenDate"])
});

export default connect(mapStateToProps, null)(DateSelectorComponent);